import { useT } from "@/i18n/LocaleContext";

/* Displayed on FR/DE pages only. Small type, muted colour, thin gold rule below. */
export const DraftBanner = () => {
  const { locale, t } = useT();
  if (locale === "en") return null;
  const text = t("draft.text");
  if (!text) return null;
  return (
    <div data-testid="draft-banner" className="bg-cream">
      <div className="mx-auto max-w-[1360px] px-6 md:px-10 lg:px-14 pt-4 pb-4">
        <p
          data-testid="draft-banner-text"
          className="font-sans text-[12px] text-navy/60 leading-relaxed"
        >
          {text}
        </p>
        <div className="mt-3 h-px w-16 bg-gold" aria-hidden />
      </div>
    </div>
  );
};

export default DraftBanner;
